import './App.css';
import { Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';

import HomePage from './pages/HomePage';
import RealEstatePage from './pages/RealEstatePage';
import AcademyPage from './pages/AcademyPage';
import CourseDetailPage from './pages/CourseDetailPage';
import NotFound from './pages/NotFound';

function App() {
  return (
    <>
      <Analytics />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="realestate" element={<RealEstatePage />} />
        <Route path="academy" element={<AcademyPage />} />
        <Route path="course/:id" element={<CourseDetailPage />} />
        <Route path="academy/course/:id" element={<CourseDetailPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
